import React, { useEffect, useState } from "react";
import { useQuery, gql } from "@apollo/client";
import { TableBody, TableRow, Icon, Button } from "@mui/material";
import { Search } from "@mui/icons-material";
import { EXPOERT_ADJUSTMENTS, LIST_ADJUSTMENT_QUERY } from "./Graphql";
import CellLink from "../HOC/CustomComponents/CellLink";
import MUITablePagination from "../HOC/MUI/TablePagination/MUITablePagination";
import { FixedTableCell } from "../HOC/CustomComponents/FixedTableCell";
import { pushUrl, windowUrl } from "../HOC/CustomFunctions/pushUrl";
import ListWrapper from "../CustomComponents/ListWrapper/ListWrapper";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useWidth from "../../Hooks/useWidth";
import config from "../../config.json";
import Grid from "@mui/material/Unstable_Grid2";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { urlParameters } from "../HOC/CustomFunctions/urlParameters";
import { CustomAutocomplete } from "../HOC/MUI/CustomAutocomplete";
import {
  LIST_CURRENCIES_DROPDOWN,
  LIST_LOOKUP_ENTRIES_DROPDOWN,
} from "../../GlobalsQuery/ListDropdown/ListDropdown";
import ControlMUItextField from "../HOC/MUI/ControlMUItextField";
import ListBranches from "../HOC/ComponentWithSpecificQuery/ListBranches";
import moment from "moment";
import MUIselect from "../HOC/MUI/MUIselect";
import MUIDateRangeCustom from "../HOC/MUI/MUIDateRangeCustom";
import formatMoney from "../../helpers/numbersDot";
import { useAccountType } from "../../Hooks/useAccountType";
import { RootStyleList, classes } from "../../GlobalStyles/ListStyle";
import { getEntityInfo } from "../../helpers/getEntityInfo";
import CustomExportExcel from "../HOC/CustomComponents/CustomExportExcel";
import { Globals } from "../HOC/Classes/Globals";
import { ROLE } from "../../helpers/helpersFunction";
const AdjustmentList = (props) => {
  const { t } = useTranslation();
  const screenWidth = useWidth();
  const history = useHistory();
  const [refetch, setrefetch] = useState(true);
  const urlQuery = urlParameters(window.location.search);
  const validUrlParameters = Object.keys(urlQuery).length !== 0;
  const [autocompleteValues, setAutocompleteValues] = useState({
    currency: null,
    type: null,
    branch: null,
    accountType: null,
    customer: null,
    employee: null,
    vendor: null,
    customAgent: null,
    agency: null,
    carrier: null,
  });
  const user = Globals.user;
  const [noData, setNoData] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(
    urlQuery["rowsPerPage"] ?? config.app.pageSize
  );
  const [drawerState, setDrawerState] = React.useState({
    top: true,
    left: screenWidth === "xs" ? false : true,
    bottom: screenWidth === "xs" ? false : true,
    right: screenWidth === "xs" ? false : true,
  });
  const [adjustmentDate, setadjustmentDate] = useState([
    urlQuery["fromDate"] ? urlQuery["fromDate"] : null,
    urlQuery["toDate"] ? urlQuery["toDate"] : null,
  ]);

  const fromDate = moment(adjustmentDate[0]).locale("en").format("YYYY-MM-DD");
  const toDate = moment(adjustmentDate[1]).locale("en").format("YYYY-MM-DD");

  let pathname = "adjustments";

  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    watch,
  } = useForm();
  const [openExport, setOpenExport] = useState(false);
  const accountType = watch("accountType");
  const dynamicAutocompleteProps = useAccountType(
    accountType,
    autocompleteValues
  );
  const initSearch = () => {
    let searchParameters = {
      ...(adjustmentDate[0] && { fromDate }),
      ...(adjustmentDate[1] && { toDate }),

      page: 0,
      refetch: true,
    };
    delete urlQuery["rowsPerPage"];
    if (validUrlParameters) {
      if (urlQuery["code"]) urlQuery["code"] = urlQuery["code"].toString();
      if (urlQuery.fromDate || urlQuery.toDate) {
        const adjustmentDate = {
          ...(urlQuery?.fromDate && { fromDate: urlQuery?.fromDate }),
          ...(urlQuery?.toDate && { toDate: urlQuery?.toDate }),
        };
        delete urlQuery["fromDate"];
        delete urlQuery["toDate"];
        urlQuery.adjustmentDate = adjustmentDate;
      }

      searchParameters = urlQuery;
    }
    return {
      ...searchParameters,
    };
  };
  const [search, setSearch] = useState(initSearch());

  const resetadjustmentDate = () => {
    setadjustmentDate([null, null]);
  };

  useEffect(() => {
    urlQuery["code"] && setValue("code", urlQuery["code"]);
    urlQuery["approved"] !== undefined &&
      setValue("approved", urlQuery["approved"]);
    urlQuery["glApproved"] !== undefined &&
      setValue("glApproved", urlQuery["glApproved"]);
    setAutocompleteValues((prev) => ({
      ...(urlQuery["branchId"] && {
        branch: urlQuery["branchId"],
      }),
      ...(urlQuery["type"] && {
        type: urlQuery["type"],
      }),
      ...(urlQuery["accountType"] && {
        accountType: urlQuery["accountType"],
      }),
      ...(urlQuery["currencyId"] && {
        currency: urlQuery["currencyId"],
      }),
      ...(urlQuery["customerId"] && {
        customer: urlQuery["customerId"],
      }),
      ...(urlQuery["employeeId"] && {
        employee: urlQuery["employeeId"],
      }),
      ...(urlQuery["vendorId"] && {
        vendor: urlQuery["vendorId"],
      }),
      ...(urlQuery["customAgentId"] && {
        customAgent: urlQuery["customAgentId"],
      }),
      ...(urlQuery["agencyId"] && {
        agency: urlQuery["agencyId"],
      }),
      ...(urlQuery["carrierId"] && {
        carrier: urlQuery["carrierId"],
      }),
    }));
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pushUrlSearch = (param) => {
    const queryParams = [];
    for (const i in param) {
      encodeURIComponent(param[i]) &&
        queryParams.push(
          encodeURIComponent(i) + "=" + encodeURIComponent(param[i])
        );
    }
    const queryString = queryParams.join("&");

    const url = history.createHref({
      pathname: `/admin/${pathname}`,
      search: "?" + queryString,
    });
    windowUrl(url);
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      (event.type === "keydown" || event.type === "submit") &&
      (event.type === "submit" || event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setDrawerState({ ...drawerState, [anchor]: open });
  };
  const filterAnchor = screenWidth === "xs" ? "bottom" : "left";

  const onSubmit = (data) => {
    filterAnchor === "bottom" &&
      setDrawerState({ ...drawerState, [filterAnchor]: false });
    refetch ? setrefetch(false) : setrefetch(true);
    let handledData = {
      ...(adjustmentDate[0] && { fromDate }),
      ...(adjustmentDate[1] && { toDate }),

      code: data.code,
      glApproved: data.glApproved,
      approved: data.approved,
      vendorId: data.vendorId,
      customerId: data.customerId,
      customAgentId: data.customAgentId,
      employeeId: data.employeeId,
      agencyId: data.agencyId,
      carrierId: data.carrierId,
      branchId: data.branchId,
      currencyId: data.currencyId,
      accountType: data.accountType,
      type: data.type,
      page: 0,
    };
    data["approved"] === "" && delete handledData["approved"];
    data["glApproved"] === "" && delete handledData["glApproved"];

    for (const key in handledData) {
      if (
        handledData[key] === undefined ||
        handledData[key] === "" ||
        handledData[key] === null ||
        handledData[key].length === 0
      ) {
        delete handledData[key];
      }
    }
    pushUrlSearch({
      ...handledData,
      rowsPerPage: rowsPerPage,
    });

    if (handledData.fromDate || handledData.toDate) {
      const adjustmentDate = {
        ...(handledData?.fromDate && { fromDate: handledData?.fromDate }),
        ...(handledData?.toDate && { toDate: handledData?.toDate }),
      };
      delete handledData["fromDate"];
      delete handledData["toDate"];
      handledData.adjustmentDate = adjustmentDate;
    }

    setSearch((prev) => ({
      ...handledData,
      refetch: !prev.refetch,
    }));
  };

  const parseData = (data) => {
    return data;
  };
  const handleChangePage = (event, newPage) => {
    pushUrlSearch({
      ...urlQuery,
      page: newPage,
      rowsPerPage: rowsPerPage,
    });

    setSearch((prev) => ({ ...prev, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    pushUrlSearch({
      ...urlQuery,
      page: 0,
      rowsPerPage: +event.target.value,
    });

    setRowsPerPage(+event.target.value);
    setSearch((prev) => ({ ...prev, page: 0 }));
  };

  const { data, loading } = useQuery(
    gql`
      ${LIST_ADJUSTMENT_QUERY.query}
    `,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache",
      partialRefetch: refetch,
      variables: {
        first: rowsPerPage,
        page: search?.page + 1,
        input: {
          approved: search.approved,
          glApproved: search.glApproved,
          ...(search.code && { code: search.code }),
          ...(search.adjustmentDate && {
            adjustmentDate: search.adjustmentDate,
          }),
          ...(search.invoiceDate && {
            invoiceDate: search.invoiceDate,
          }),
          ...(search.referenceDate && {
            referenceDate: search.referenceDate,
          }),
          ...(search.branchId && {
            branchId: search.branchId,
          }),
          ...(search.currencyId && {
            currencyId: search.currencyId,
          }),

          ...(search.accountType && {
            accountType: search.accountType,
          }),
          ...(search.type && {
            type: search.type,
          }),
          ...(search.carrierId && {
            carrierId: search.carrierId,
          }),
          ...(search.agencyId && {
            agencyId: search.agencyId,
          }),
          ...(search.employeeId && {
            employeeId: search.employeeId,
          }),
          ...(search.customAgentId && {
            customAgentId: search.customAgentId,
          }),
          ...(search.customerId && {
            customerId: search.customerId,
          }),
          ...(search.vendorId && {
            vendorId: search.vendorId,
          }),
        },
      },
      onCompleted: () => {
        setNoData(false);
      },
    }
  );
  const filters = {
    approved: search.approved,
    glApproved: search.glApproved,
    ...(search.code && { code: search.code }),
    ...(search.adjustmentDate && {
      adjustmentDate: search.adjustmentDate,
    }),
    ...(search.invoiceDate && {
      invoiceDate: search.invoiceDate,
    }),
    ...(search.referenceDate && {
      referenceDate: search.referenceDate,
    }),
    ...(search.branchId && {
      branchId: search.branchId,
    }),
    ...(search.currencyId && {
      currencyId: search.currencyId,
    }),

    ...(search.accountType && {
      accountType: search.accountType,
    }),
    ...(search.type && {
      type: search.type,
    }),
    ...(search.carrierId && {
      carrierId: search.carrierId,
    }),
    ...(search.agencyId && {
      agencyId: search.agencyId,
    }),
    ...(search.employeeId && {
      employeeId: search.employeeId,
    }),
    ...(search.customAgentId && {
      customAgentId: search.customAgentId,
    }),
    ...(search.customerId && {
      customerId: search.customerId,
    }),
    ...(search.vendorId && {
      vendorId: search.vendorId,
    }),
  };
  const openExportDialog = () => {
    setOpenExport(true);
  };
  const fields = [
    { name: "CODE", label: t("code") },
    { name: "DATE", label: t("date") },
    { name: "BRANCH", label: t("branch") },
    { name: "ACCOUNT_TYPE", label: t("accountType") },
    { name: "ACCOUNT_NAME", label: t("accountName") },
    { name: "DOCUMENT_CODE", label: t("documentCode") },
    { name: "CURRENCY", label: t("currency") },
    { name: "AMOUNT", label: t("amount") },
    { name: "EXCHANGE_RATE", label: t("exchangeRate") },
    { name: "TYPE", label: t("type") },
    { name: "APPROVED", label: t("approved") },
    { name: "GL_APPROVED", label: t("glApproved") },
  ];
  const handelAutocompleteDefaultValue = (data, id, fieldName) => {
    const defaultValue = data[Object.keys(data)[0]].find((i) => i.code === id);
    defaultValue &&
      setAutocompleteValues((prev) => ({
        ...prev,
        [fieldName]: defaultValue,
      }));
  };
  const listBills = data?.[`listAdjustments`]?.data;

  const icons = [
    {
      id: "filterList",
      action: toggleDrawer(filterAnchor, !drawerState[filterAnchor]),
    },
    {
      id: "add",
      action: () => pushUrl(props, `/admin/${pathname}/create`),
      permission: `freight.adjustment.create`,
    },
    {
      id: "export",
      action: openExportDialog,
      disabled: !Boolean(data),
    },
  ];

  return (
    <RootStyleList>
      {openExport && (
        <CustomExportExcel
          filters={filters}
          fields={fields}
          localStorageName={"export-adjustments"}
          ExportMutation={EXPOERT_ADJUSTMENTS}
          mutationName={"exportAdjustments"}
          openExport={openExport}
          setOpenExport={setOpenExport}
        />
      )}
      <ListWrapper
        drawerState={drawerState[filterAnchor]}
        icons={icons}
        path={props.match.path}
        empty={listBills?.length === 0}
        loading={loading}
        filters={
          <Grid
            container
            component="form"
            onSubmit={handleSubmit(onSubmit)}
            className={classes.filterForm}
          >
            <Grid
              container
              item
              sm={12}
              justifyContent="flex-start"
              spacing={1}
              className={classes.filterField}
            >
              <Grid item sm={12} alignItems="flex-start">
                <MUIDateRangeCustom
                  startText={t("adjustmentDate")}
                  value={adjustmentDate}
                  onChangeValue={(value) => setadjustmentDate(value)}
                  resetDate={resetadjustmentDate}
                />
              </Grid>
              <Grid item sm={12} alignItems="flex-start">
                <ControlMUItextField
                  control={control}
                  errors={errors}
                  name={"code"}
                  label={t("code")}
                />
              </Grid>

              <Grid item sm={12} alignItems="flex-start">
                <ListBranches
                  control={control}
                  errors={errors}
                  name={"branchId"}
                  defaultValue={autocompleteValues.branch}
                  skipDefaultBranch={true}
                  skip={noData}
                />
              </Grid>
              {user?.account?.__typename !== ROLE.employee && (
                <>
                  <Grid item sm={12} alignItems="flex-start">
                    <CustomAutocomplete
                      valueKey="code"
                      control={control}
                      errors={errors}
                      skip={noData}
                      name={"accountType"}
                      label={t("accountType")}
                      onCompleted={(data) =>
                        handelAutocompleteDefaultValue(
                          data,
                          urlQuery["accountType"],
                          "accountType"
                        )
                      }
                      parseData={(data) => parseData(data)}
                      variables={{ input: { code: "FR_ACCOUNT_TYPE" } }}
                      query={LIST_LOOKUP_ENTRIES_DROPDOWN.query}
                      defaultValue={autocompleteValues.accountType}
                      onChangeValue={(e) => {
                        setValue(dynamicAutocompleteProps.name, "");
                      }}
                    />
                  </Grid>
                  <Grid item sm={12} alignItems="flex-start">
                    <CustomAutocomplete
                      control={control}
                      errors={errors}
                      disabled={!watch("accountType")}
                      name={dynamicAutocompleteProps.name}
                      label={dynamicAutocompleteProps.label}
                      parseData={(data) => parseData(data)}
                      query={dynamicAutocompleteProps.query}
                      variables={{
                        input: dynamicAutocompleteProps?.input,
                      }}
                      defaultValue={dynamicAutocompleteProps.defaultValue}
                    />
                  </Grid>
                </>
              )}
              <Grid item sm={12} alignItems="flex-start">
                <MUIselect
                  name={"approved"}
                  label={t("approved")}
                  control={control}
                  errors={errors}
                  data={[
                    { key: t("false"), value: false },
                    { key: t("true"), value: true },
                  ]}
                />
              </Grid>
              <Grid item sm={12} alignItems="flex-start">
                <MUIselect
                  name={"glApproved"}
                  label={t("glApproved")}
                  control={control}
                  errors={errors}
                  data={[
                    { key: t("false"), value: false },
                    { key: t("true"), value: true },
                  ]}
                />
              </Grid>
              <Grid item sm={12} alignItems="flex-start">
                <CustomAutocomplete
                  control={control}
                  errors={errors}
                  skip={noData}
                  name={"currencyId"}
                  label={t("currency")}
                  parseData={(data) => parseData(data)}
                  query={LIST_CURRENCIES_DROPDOWN.query}
                  defaultValue={autocompleteValues.currency}
                />
              </Grid>

              <Grid item sm={12} alignItems="flex-start">
                <CustomAutocomplete
                  valueKey="code"
                  control={control}
                  errors={errors}
                  skip={noData}
                  name={"type"}
                  label={t("type")}
                  onCompleted={(data) =>
                    handelAutocompleteDefaultValue(
                      data,
                      urlQuery["type"],
                      "type"
                    )
                  }
                  parseData={(data) => parseData(data)}
                  variables={{ input: { code: "ACCOUNT_ADJUSTENTS" } }}
                  query={LIST_LOOKUP_ENTRIES_DROPDOWN.query}
                  defaultValue={autocompleteValues.type}
                />
              </Grid>
            </Grid>
            <Grid
              container
              item
              sm={12}
              className={classes.button}
              alignItems="flex-end"
              justifyContent="flex-end"
            >
              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="medium"
                color="primary"
                startIcon={<Search />}
              >
                {t("search")}
              </Button>
            </Grid>
          </Grid>
        }
        tableHeaders={[
          {
            name: "code",
          },
          {
            name: "adjustmentDate",
          },
          {
            name: "branch",
          },
          {
            name: "accountType",
          },
          {
            name: "payeeName",
          },

          {
            name: "value",
          },
          {
            name: "currency",
          },
          {
            name: "exchangeRate",
          },
          {
            name: "type",
          },
          {
            name: "documentType",
          },
          {
            name: "documentCode",
          },
          {
            name: "approved",
          },
          {
            name: "glApproved",
          },
        ]}
        tableBody={
          <TableBody>
            {listBills &&
              listBills?.map((row, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    <CellLink pathname={`/admin/${pathname}/${row?.id}`}>
                      {row?.code}
                    </CellLink>
                    <FixedTableCell>{row?.adjustmentDate}</FixedTableCell>
                    <CellLink pathname={`/admin/branches/${row?.branch?.id}`}>
                      {row?.branch?.name}
                    </CellLink>
                    <FixedTableCell>{row?.accountType?.name}</FixedTableCell>
                    <CellLink
                      pathname={`/admin/${getEntityInfo(row).entityPath}/${
                        getEntityInfo(row).id || ""
                      }`}
                    >
                      {getEntityInfo(row).entity
                        ? row[getEntityInfo(row).entity]?.name || ""
                        : ""}
                    </CellLink>

                    <FixedTableCell>{formatMoney(row?.amount)}</FixedTableCell>
                    <FixedTableCell>{row?.currency?.name}</FixedTableCell>
                    <FixedTableCell>{row?.exchangeRate}</FixedTableCell>
                    <FixedTableCell>{row?.type?.name}</FixedTableCell>
                    <FixedTableCell>
                      {row?.invoice
                        ? t("invoice")
                        : row?.bill
                        ? t("bill")
                        : "-"}
                    </FixedTableCell>
                    {row?.type?.code === "CR_ADJ" ? (
                      <CellLink
                        pathname={`/admin/invoices/${row?.invoice?.id}`}
                      >
                        {row?.invoice?.code}
                      </CellLink>
                    ) : (
                      <CellLink pathname={`/admin/bills/${row?.bill?.id}`}>
                        {row?.bill?.code}
                      </CellLink>
                    )}
                    <FixedTableCell>
                      {row?.approved ? (
                        <Icon className={classes.iconColor}>
                          check_circle_outline
                        </Icon>
                      ) : (
                        <Icon color="error">highlight_off</Icon>
                      )}
                    </FixedTableCell>
                    <FixedTableCell>
                      {row?.glApproved ? (
                        <Icon className={classes.iconColor}>
                          check_circle_outline
                        </Icon>
                      ) : (
                        <Icon color="error">highlight_off</Icon>
                      )}
                    </FixedTableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        }
        pagination={
          <MUITablePagination
            count={data?.listAdjustments?.paginatorInfo?.total}
            rowsPerPage={rowsPerPage}
            page={!data?.listAdjustments ? 0 : search.page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        }
      />
    </RootStyleList>
  );
};

export default AdjustmentList;
